import React, { Component } from 'react'
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as BsIcons from 'react-icons/bs';

import styles from './About.module.css'

import profile1 from './resource/profile1.jpg'

import { Button } from '@material-ui/core';
import Timeline1 from './Timeline1';
import AnupamGhosh_CV1 from './resource/AnupamGhosh_CV1.pdf'

class About extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
             aboutPage:true
        }
    }
    
    render() {
        var change=e=>{
            this.setState({aboutPage:!this.state.aboutPage})
          }

        const about1=(
            <div>
                <div className={styles.section1}>
                <div className={styles.container1}>
                    <div className={styles.content_section}>
                        <div className={styles.title}>
                            <h1>About Me</h1>
                        </div>
                        <div className={styles.content}>
        
                            <p>
                                Hello My Name is Anupam Ghosh. I am 21 years old.
                                Curently doing my B.Tech from MAKAUT, WestBengal.
                                I am learner and enthusiastic to learn more about Web development and other
                                kinds of developments.Also 
                                I like to participate in Competitive programming and
                                know more about math,physics etc these type of things.
                                Playing Football and drawing are also my hobbies.
                            </p>
                            
                            <Button onClick={change} className={styles.btn}>Know more..</Button>
                        </div>

                        <div className={styles.social}>
                            <a href="https://www.facebook.com/profile.php?id=100028117720818" target="_blank" rel="noopener noreferrer"><FaIcons.FaFacebook/></a>
                            <a href="https://www.linkedin.com/in/anupam-ghosh-b9a692199" target="_blank" rel="noopener noreferrer"><FaIcons.FaLinkedin/></a>
                            <a href="https://www.instagram.com/anupam8500/" target="_blank" rel="noopener noreferrer"><AiIcons.AiOutlineInstagram/></a>

                        </div>
                    </div>

                    <div className={styles.image_section}>
                        <img src={profile1} alt="profile"/>
                    </div>
                </div>
            </div>    
            </div>
    );

    const about2=(
            <div className={styles.about2_main}>
                <h1 className={styles.H1}>Progress Track...</h1>
                <Timeline1/>
                <div className={styles.b1}><Button onClick={change} className={styles.btn2}><b>See less...</b></Button></div>
                <a href={AnupamGhosh_CV1} target="_blank" rel="noopener noreferrer" download="CV_AnupamGhosh.pdf" className={styles.anch}>Want to download my CV? Click here..</a>
                
            </div>    
    );

    const z=this.state.aboutPage
        return (
            <div>
                {z?(about1):(about2)}
            </div>
        )
    }
}

export default About
